<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">COE bidding results</h1>
    <app-navpath />
  </div>
  <section class="content-container">
    <h2 class="sub-heading w-full border-b">Upload COEs list</h2>
    <div class="my-3 flex justify-between">
      <label class="block px-8 text-sm font-bold">
        File Location
        <input
          type="file"
          name=""
          id=""
          class="ml-16"
          accept=".xlsx, .xls"
          (change)="onFileChange($event)"
        />
      </label>
      <div class="mt-2 flex w-fit gap-1">
        <button
          class="shorter-btn save-btn"
          (click)="ShowFile()"
          [disabled]="!enableUpload"
        >
          <fa-icon [icon]="faUpload" class="mr-1" />Upload and show
          list
        </button>
        <button class="shorter-btn clear-btn" (click)="clear()">
          <fa-icon [icon]="faBroom" class="mr-1" />Clear
        </button>
      </div>
    </div>
  </section>
  <section class="content-container">
    <h2 class="sub-heading w-full border-b">Select COEs from list</h2>
    <app-data-form
      [dataFields]="selectCOE"
      [dataName]="'selectCOE'"
      (updateFields_child)="updateFields($event)"
    />
  </section>
  <section class="content-container" *ngIf="TableEntries.length > 0">
    <div class="my-3 flex justify-between border-b">
      <h2 class="sub-heading">COEs List</h2>
      <button class="shorter-btn save-btn w-fit" (click)="update()">
        <fa-icon [icon]="faUpload" class="mr-1" />Update COE Status
      </button>
    </div>
    <app-data-table
      [tableHeaders]="TableHeaders"
      [tableEntries]="TableEntries"
      [pagination]="false"
    />
  </section>
</div>
